module.exports = __webpack_public_path__ + "static/media/Header-Logo-Mundial.0f48a3b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Header-Logo-Mundial.png
// module id = 718
// module chunks = 0